import ActionButton from "@/components/buttons/ActionButton";
import { Card, Form } from "antd";
import { useTranslation } from "react-i18next";
import { SloveniaCompetitionResultFilterPageRequest } from "../types";
import { SloveniaCompetitionFilterForm } from "./forms/SloveniaCompetitionFilterForm";

type Props = {
  searchParams: SloveniaCompetitionResultFilterPageRequest;
  updateSearchParams: (params: SloveniaCompetitionResultFilterPageRequest, append?: boolean, replace?: boolean) => void;
};

export const SloveniaCompetitionFilter = ({ searchParams, updateSearchParams }: Props) => {
  const { t } = useTranslation();

  const [filterForm] = Form.useForm<SloveniaCompetitionResultFilterPageRequest>();

  return (
    <Card
      className="card-box"
      title={<h2>{t("page.competitionSlovenia")}</h2>}
      extra={
        <ActionButton
          color="danger"
          size="middle"
          variant="outlined"
          icon="reload"
          onClick={() => {
            filterForm.resetFields();
            updateSearchParams(filterForm.getFieldsValue());
          }}
        >
          {t("common.resetFilter")}
        </ActionButton>
      }
    >
      <SloveniaCompetitionFilterForm
        searchParams={searchParams}
        form={filterForm}
        onFilterSubmit={updateSearchParams}
      />
    </Card>
  );
};
